export default __webpack_public_path__ + "static/media/2_active.1373a0fc.png";